export const DEFAULT_TIME_ZONE = 'America/Chicago'

export const USER_TIME_ZONE_OPTIONS = [
  { value: 'America/Chicago', label: 'Central Time' },
  { value: 'America/New_York', label: 'Eastern Time' },
  { value: 'America/Denver', label: 'Mountain Time' },
  { value: 'America/Los_Angeles', label: 'Pacific Time' },
  { value: 'America/Phoenix', label: 'Arizona Time' },
  { value: 'America/Anchorage', label: 'Alaska Time' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time' },
  { value: 'UTC', label: 'UTC' },
] as const

export type UserTimeZone = (typeof USER_TIME_ZONE_OPTIONS)[number]['value']

const USER_TIME_ZONE_VALUES = new Set<string>(USER_TIME_ZONE_OPTIONS.map((option) => option.value))

export function isUserTimeZone(value: string): value is UserTimeZone {
  return USER_TIME_ZONE_VALUES.has(value)
}

export function normalizeUserTimeZone(value: string | null | undefined): UserTimeZone {
  return value && isUserTimeZone(value) ? value : DEFAULT_TIME_ZONE
}

export function formatDateTimeInUserZone(value: Date, timeZone: string | null | undefined): string {
  const normalizedTimeZone = normalizeUserTimeZone(timeZone)
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: normalizedTimeZone,
    timeZoneName: 'short',
  }).format(value)
}
